import Vue from 'vue';
import ElementUI from 'element-ui';
import dataV from '@jiaminghi/data-view';
import fullscreen from 'vue-fullscreen';
import '@/assets/styles/normalize.css';
import store from '@/store';
import router from '@/router';
import App from '@/App';
// import NPlayer from '@nplayer/vue';
import '@/components';
import '@/assets/icons';
import '@/assets/styles/index.scss';
import { apiInstall } from '@/api';
import VueI18n from 'vue-i18n';
import importFilter from './filter';
import importDirective from './directive';
import { appTitle } from '@/utils';
import { i18n } from './lang';
import './assets/theme/default/theme/index.css';

/* ---------使用语言包-----------*/
Vue.use(VueI18n);

/**
 * 注册过滤器
 */
importFilter(Vue);

/**
 * 注册指令
 */
importDirective(Vue);

Vue.use(apiInstall);

Vue.config.productionTip = false;
Vue.config.devtools = true
// Vue.use(NPlayer);

// 全局修改对话框点击遮罩关闭效果
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI, {
  size: 'small',
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value),
});

/**
 * 数据大屏
 */
Vue.use(dataV);

/**
 * 全屏组件
 */
Vue.use(fullscreen);

router.beforeEach((to, _from, next) => {
  // 切换路由，要先关闭loading
  store.commit('setLoading', false);
  // 处理vue-i18n的转化
  if (localStorage.getItem('lang')) i18n.locale = localStorage.getItem('lang');

  document.title = to.meta.title ? `${appTitle} | ${to.meta.title}` : appTitle;

  if (['/sign', '/forgetPassword'].includes(to.path)) {
    next();
  } else {
    store.dispatch('InitUserData').then(() => {
      if (store.state.auth.hadSetRoutes) {
        // 切换项目，重定向到首页
        if (to.name === 'ProjectIndex') {
          store.commit('project/SWITCH_PROJECT', to.params.projectId);
          next({
            name: 'Home',
            replace: true,
            query: { ...to.params },
          });
        } else {
          next();
        }
      } else {
        router.addRoutes(store.getters.addRoutes);
        store.commit('SET_ROUTES');
        router.replace(to.fullPath);
        next();
      }
    }).catch(() => {
      if (to.path === '/sign') {
        next();
      } else {
        next({ path: '/sign', query: { redirect: to.fullPath } });
      }
    });
  }
});

Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return this.$root.bus;
  },
});

const bus = new Vue();

new Vue({ // eslint-disable-line no-new
  store,
  router,
  el: '#app',
  i18n,
  // render: h => h(App),
  data: { bus },
  template: '<App/>',
  components: { App },
});

